export class MovimientoDetails
{
    importe: number
    concepto: string
    tipo_movimiento: string
    fecha: Date
}